import { presenceCost, validate, validateEmailRule } from '@/core/tools'
const constraints = {
    email: { presence: presenceCost, email: validateEmailRule },
}

export const validateEmail = (data: any) => {
    return validate<any>(data, constraints)
}
